(function () {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Light header stays tall; only .scrolled slightly compresses height
    header.classList.add('is-solid');
  }

  function initMobileMenu() {
    var drawer = document.getElementById('mobile-menu');
    var openBtn = document.getElementById('hamburger-toggle');
    var closeBtn = document.getElementById('close-mobile-menu');
    if (!drawer || !openBtn) return;

    var open = function () {
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    var close = function () {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    };

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', close);
    });

    drawer.querySelectorAll('.mobile-dropdown-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mobile-nav-item');
        if (item) item.classList.toggle('open');
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-faq] .faq-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        if (!item) return;
        var open = item.classList.contains('open');
        item.parentElement.querySelectorAll('.faq-item').forEach(function (el) {
          el.classList.remove('open');
          var t = el.querySelector('.faq-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /**
   * Interactive Cocky Club box showcase:
   * gold star markers on the image highlight matching callout cards.
   */
  function initBoxShowcase() {
    var root = document.querySelector('[data-box-showcase]');
    if (!root) return;

    var markers = root.querySelectorAll('.marker');
    var calloutCards = root.querySelectorAll('.callout-card');
    if (!markers.length || !calloutCards.length) return;

    var clearStates = function () {
      markers.forEach(function (m) { m.classList.remove('active'); });
      calloutCards.forEach(function (c) { c.classList.remove('highlighted'); });
    };

    var highlightElement = function (id) {
      if (!id) return;
      clearStates();
      var activeMarker = root.querySelector('.marker[data-callout="' + id + '"]');
      var activeCard = root.querySelector('.callout-card[data-target="' + id + '"]');
      if (activeMarker) activeMarker.classList.add('active');
      if (activeCard) {
        activeCard.classList.add('highlighted');
        if (window.innerWidth <= 900) {
          activeCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    };

    markers.forEach(function (marker) {
      var calloutId = marker.getAttribute('data-callout');
      marker.addEventListener('click', function (e) {
        e.stopPropagation();
        highlightElement(calloutId);
      });
      marker.addEventListener('mouseenter', function () {
        highlightElement(calloutId);
      });
    });

    calloutCards.forEach(function (card) {
      var targetId = card.getAttribute('data-target');
      card.addEventListener('mouseenter', function () {
        highlightElement(targetId);
      });
      card.addEventListener('mouseleave', clearStates);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) clearStates();
    });
  }

  function initProductLightbox() {
    var gallery = document.querySelector('[data-product-gallery]');
    var lightbox = document.getElementById('ProductLightbox');
    if (!gallery || !lightbox) return;

    var triggers = gallery.querySelectorAll('.product-gallery-trigger');
    if (!triggers.length) return;

    var imageEl = lightbox.querySelector('[data-lightbox-image]');
    var videoEl = lightbox.querySelector('[data-lightbox-video]');
    var embedEl = lightbox.querySelector('[data-lightbox-embed]');
    var countEl = lightbox.querySelector('[data-lightbox-count]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var index = 0;
    var lastFocus = null;

    var items = Array.prototype.map.call(triggers, function (btn) {
      var img = btn.querySelector('img');
      return {
        type: btn.getAttribute('data-media-type') || 'image',
        src: btn.getAttribute('data-full') || (img && (img.currentSrc || img.src)) || '',
        videoSrc: btn.getAttribute('data-video-src') || '',
        embedSrc: btn.getAttribute('data-embed-src') || '',
        alt: (img && img.getAttribute('alt')) || ''
      };
    });

    var stopMedia = function () {
      if (videoEl) {
        videoEl.pause();
        videoEl.removeAttribute('src');
        videoEl.load();
        videoEl.hidden = true;
      }
      if (embedEl) {
        embedEl.removeAttribute('src');
        embedEl.hidden = true;
      }
      if (imageEl) imageEl.hidden = false;
    };

    var show = function (i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      var item = items[index];
      stopMedia();
      if (item.type === 'video' && item.videoSrc && videoEl) {
        imageEl.hidden = true;
        videoEl.hidden = false;
        videoEl.poster = item.src;
        videoEl.setAttribute('aria-label', item.alt || 'Product video');
        videoEl.src = item.videoSrc;
        var playPromise = videoEl.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      } else if (item.type === 'external_video' && item.embedSrc && embedEl) {
        imageEl.hidden = true;
        embedEl.hidden = false;
        embedEl.title = item.alt || 'Product video';
        embedEl.src = item.embedSrc;
      } else {
        imageEl.src = item.src;
        imageEl.alt = item.alt;
      }
      if (countEl) countEl.textContent = index + 1 + ' / ' + items.length;
      lightbox.classList.toggle('is-single', items.length < 2);
    };

    var open = function (i) {
      lastFocus = document.activeElement;
      show(i);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = lightbox.querySelector('.product-lightbox-close');
      if (closeBtn) closeBtn.focus();
    };

    var close = function () {
      stopMedia();
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    triggers.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        open(i);
      });
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(index + 1);
      });
    }

    imageEl.addEventListener('click', function () {
      if (items.length > 1) show(index + 1);
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  function initProductPage() {
    var form = document.querySelector('[data-product-form]') || document.getElementById('product-form');
    if (!form) return;

    var qtyInput = form.querySelector('#product-quantity, .qty-input-bloop');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    var variantSelect = form.querySelector('#product-variant');
    var priceEl = document.querySelector('[data-product-price] .current-price') || document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    if (minus && qtyInput) {
      minus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
    }
    if (plus && qtyInput) {
      plus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    form.querySelectorAll('[data-variant-pills] .pill-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-variant-pills] .pill-option-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');
        var id = btn.getAttribute('data-variant-id');
        var price = btn.getAttribute('data-price');
        var available = btn.getAttribute('data-available') === 'true';
        if (variantSelect && id) variantSelect.value = id;
        if (priceEl && price) priceEl.textContent = price;
        if (addBtn) {
          var labelIn = addBtn.getAttribute('data-label-available') || 'Add to Bag';
          var labelOut = addBtn.getAttribute('data-label-soldout') || 'Sold out';
          addBtn.disabled = !available;
          addBtn.setAttribute('data-available', available ? 'true' : 'false');
          addBtn.textContent = available ? labelIn : labelOut;
        }
      });
    });

    document.querySelectorAll('[data-product-accordion] .bloop-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.bloop-accordion-item');
        if (!item) return;
        var wasActive = item.classList.contains('active');
        item.parentElement.querySelectorAll('.bloop-accordion-item').forEach(function (el) {
          el.classList.remove('active');
        });
        if (!wasActive) item.classList.add('active');
      });
    });

    var tabsRoot = document.querySelector('[data-product-tabs]');
    if (tabsRoot) {
      var triggers = tabsRoot.querySelectorAll('.tab-trigger-btn');
      var panels = tabsRoot.querySelectorAll('[data-tab-panel]');
      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab');
          triggers.forEach(function (t) { t.classList.remove('active'); });
          btn.classList.add('active');
          panels.forEach(function (panel) {
            var match = panel.getAttribute('data-tab-panel') === id;
            panel.classList.toggle('active', match);
            if (match) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    }
  }

  function initAboutFounderBios() {
    var openButtons = document.querySelectorAll('[data-bio-open]');
    if (!openButtons.length) return;

    var lastFocus = null;

    function closeModal(modal) {
      if (!modal || modal.hasAttribute('hidden')) return;
      modal.setAttribute('hidden', '');
      document.body.classList.remove('about-bio-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function openModal(key, trigger) {
      var modal = document.getElementById('bio-modal-' + key);
      if (!modal) return;
      lastFocus = trigger || document.activeElement;
      modal.removeAttribute('hidden');
      document.body.classList.add('about-bio-modal-open');
      var closeBtn = modal.querySelector('.about-bio-modal-close');
      if (closeBtn) closeBtn.focus();
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-bio-open'), btn);
      });
    });

    document.querySelectorAll('.about-bio-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-bio-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeModal(modal);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.about-bio-modal').forEach(closeModal);
    });

    var canHover = window.matchMedia('(hover: hover)').matches;
    if (!canHover) {
      document.querySelectorAll('.about-founder-portrait').forEach(function (portrait) {
        var card = portrait.closest('.about-founder-card');
        if (!card) return;
        var hint = portrait.querySelector('.about-founder-hover-hint');
        if (hint) hint.textContent = 'Tap for fun ✦';
        portrait.addEventListener('click', function (e) {
          e.preventDefault();
          card.classList.toggle('is-flipped');
        });
      });
    }
  }

  function initCartPage() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    form.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          input.value = Math.max(0, v - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          input.value = v + 1;
        });
      }
    });
  }

  function initCorpAppsSlider() {
    var shells = document.querySelectorAll('[data-corp-apps-slider]');
    if (!shells.length) return;

    shells.forEach(function (shell) {
      var track = shell.querySelector('[data-corp-apps-track]');
      var prev = shell.querySelector('[data-corp-apps-prev]');
      var next = shell.querySelector('[data-corp-apps-next]');
      if (!track) return;

      var cardStep = function () {
        var card = track.querySelector('.corporate-app-card');
        if (!card) return 280;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      };

      var updateNav = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMobileMenu();
    initFaq();
    initBoxShowcase();
    initProductLightbox();
    initProductPage();
    initCartPage();
    initAboutFounderBios();
    initCorpAppsSlider();
  });
})();

